import React from 'react';

function UserInfoRow({ label, data, value, style }) {
  return (
    <div className="row mt-2">
      <div className="col-md-13"><label className="labels" >{label}</label></div>
      <div className="col-md-14"><label className="labels details-style" style={style}>{data}{value}</label></div>
    </div>
  );
}

export default UserInfoRow;